import script from "./UsuarioPerfilEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioPerfilEditPage.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioPerfilEditPage.vue?vue&type=style&index=0&id=47cf8f36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47cf8f36"]])

export default __exports__